import React from "react";
import Link from "../Link";
import { Tenant } from "utils/tenants";

function Copyright() {
    return (
        <div className="copyright ">
            <span className="font-small text--grey">
                Copyright ©{" "}
                <Link href={Tenant.getWebsite()} target={"_blank"}>
                    {Tenant.getName()}
                </Link>{" "}
                {new Date().getFullYear()}
            </span>
        </div>
    );
}

export default Copyright;
